"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Base = /*#__PURE__*/function () {
  function Base() {
    _classCallCheck(this, Base);

    this._props = [];
  }

  _createClass(Base, [{
    key: "initProps",
    value: function initProps(data) {
      var _this = this;

      var hasOwnProperty = Object.prototype.hasOwnProperty;

      function _has(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }

      this._props.forEach(function (name) {
        if (!_has(data, name)) {
          throw new Error("Not found property: ".concat(name));
        }

        if (name === "cost" || name === "deadline" || name === "lighthouseFee" || name === "nonce") {
          _this[name] = Number(data[name]);
        } else {
          _this[name] = data[name];
        }
      });
    }
  }, {
    key: "toObject",
    value: function toObject() {
      var _this2 = this;

      var data = {};

      this._props.forEach(function (name) {
        data[name] = _this2[name];
      });

      return data;
    }
  }, {
    key: "encode",
    value: function encode() {
      var msg = this.toObject();

      if (msg.signature) {
        msg.signature = msg.signature.replace(/0x/i, "");
      }

      return Buffer.from(JSON.stringify(msg));
    }
  }]);

  return Base;
}();

exports["default"] = Base;